import {Fancybox} from '@fancyapps/ui'

export function initProductFancybox() {
  Fancybox.bind('[data-fancybox4="product"]', {
    groupAll: true,
  })
}
